import React, { useEffect, useMemo, useState } from "react";
import DataTable from "../DataTable";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { Alert, Button, Stack, TextField, Typography } from "@mui/material";
const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    {/* <TextField
      id="search"
      type="text"
      placeholder="Filter By Name"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
    />
    <Button type="button" onClick={onClear}>
      X
    </Button> */}
  </>
);

export default function AnnouncementListTable(props) {
  const [filterText, setFilterText] = useState("");
  const [isEnabled, setIsEnabled] = useState(null);
  // const filteredItems = props.data.filter(
  //   (item) =>
  //     item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  // );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText]);
  // const [professionList, setProfessionList] = useState([]);
  // const [show, setShow] = useState(false);
  // const [selectedRow, setSelectedRow] = useState({});

  // const baseEndpointURL =
  //   ApiEndpoints.root +
  //   ApiEndpoints.management.base +
  //   ApiEndpoints.management.profession.base;

  const onChangeValue = (e, key, key2 = "") => {
    const obj = props?.selectedRow[0];
    key2 ? (obj[key][key2] = e) : (obj[key] = e);
    props?.onSelectedRowsChange({ selectedRows: props?.selectedRow });
  };

  const columns = [
    {
      name: <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Description</Typography>,
      selector: (row) => row.body,
      sortable: true,
      width: "60%",
      headerStyle: (selector, id) => {
        return { width: "60px", textAlign: "center" };
      },
      cell: (row, index, column, id) => {
        if (props?.edit && row?._id == props?.selectedRow[0]?._id) {
          return (
            <textarea
              rows="10"
              class="cst-input"
              onChange={(e) => onChangeValue(e.target?.value, "body")}
            >
              {row?.body}
            </textarea>
          );
        } else {
          return <p style={{ marginTop: 15 }}>{row.body}</p>;
        }
      },
    },
    {
      name: <Typography variant="subtitle2" sx={{ fontWeight: 700, width: '100%', textAlign: 'center' }}>Status</Typography>,
      selector: (row) => row.status,
      cell: (row, index, column, id) => {
        var switchBool = row?.status?.toLowerCase() == "active" ? true : false;
        return (
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Switch
              defaultChecked={isEnabled != null ? isEnabled : switchBool}
              onClick={(e) => {
                let switchAnnValue = 'active';
                if (e?.target?.checked) {
                  switchAnnValue = 'active';
                }
                else {
                  switchAnnValue = 'inactive';
                }
                props.setAnnouncementSwitchRow(row);
                props.onChangeAnnouncementSwitch(row, switchAnnValue);
              }}
            />
          </div>

        );
      },

    },
    {
      name: <Typography variant="subtitle2" sx={{ fontWeight: 700, width: '100%', textAlign: 'center' }}>Actions</Typography>,
      sortable: true,
      cell: (row) => (
        <div style={{ width: '100%', textAlign: 'center' }}>
          <IconButton
            aria-label="delete"
            color="primary"
            onClick={() => {
              props.onAnnouncementDeletePress({
                _id: row._id,
                name: row.body,
              });
            }}
          >
            <DeleteRoundedIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => {
              props.setEditAnnouncement(true)
              props.setEditAnnouncementData(row);
              props.setEditAnnouncementObj({
                ...props.editAnnouncementObj,
                _id: row?._id,
                city_id: row?.city_id,
                user_id: row?.user_id,
                body: row?.body,
                status: row?.status
              });
            }}
          >
            <EditRoundedIcon fontSize="medium" />
          </IconButton>
        </div>
      ),
    },
  ];
  const customStyles = {
    
    cells: {
      style: {

      }
    },

  }

  const conditionalRowStyles = {
    headRow: {
      style: {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "rgba(0,0,0,0.6)",
        borderRadius: "5px",
      },
    },
  };

  return (
    <DataTable
      columns={columns}
      data={props.data}
      persistTableHead
      pagination
      paginationServer
      progressPending={props?.progressPending}
      progressComponent={props?.progressComponent}
      paginationTotalRows={10}
      onChangeRowsPerPage={props?.onChangeRowsPerPage}
      customStyles={conditionalRowStyles}
      direction="vertical"
      clearRow={props?.clearRow}
      striped={true}
      onSelectedRowsChange={props?.onSelectedRowsChange}
      onRowDoubleClicked={(row, event) => {
        if (props.selectedAnnouncementrows?.length == 1) {
          props.setEditAnnouncement(!props.editAnnouncement);
        } else {
          props.setAnnouncementAlert(true);
          setTimeout(() => {
            props.setAnnouncementAlert(false);
          }, 5000);
        }
      }}
    />
  );
}
